import { showLegalBannerDisclaimer } from "../../../common-deprecated/settings/utils/commonSettingUtils";
import { showAemMonthlyRates } from "../../../common-deprecated/settings/utils/financeSettingUtilsAem";
import { AemFmComponent } from "../../../common-deprecated/utils/aemFlexibilityMatrixUtils";
import type { LegalBannerDisclaimerDataType } from "../../shared-logic/types/FinanceTypes";
import { createFinanceMinMax } from "../../shared-logic/utils/legalBannerDisclaimerUtils";
import { useCompareV2Selector } from "../redux/store";

const useDisclaimerContent = (): LegalBannerDisclaimerDataType | null => {
    const grades = useCompareV2Selector((state) => state.newCarCompare.grades);
    const [hasNLFinanceDisclaimer, hasFinance] = useCompareV2Selector(({ commonSettings }) => [
        showLegalBannerDisclaimer(commonSettings),
        showAemMonthlyRates(commonSettings, AemFmComponent.Compare, "new"),
    ]);
    if (!hasNLFinanceDisclaimer || !hasFinance) return null;

    const tableInput = grades.map((grade) => ({
        price: { monthly: grade.finance?.rate || 0 },
        finance: grade.finance?.financeInfo,
    }));

    return createFinanceMinMax(tableInput);
};
export default useDisclaimerContent;
